var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reservation-setup-parameter',{attrs:{"parameter_id":_vm.SETUP_PARAMETER_CURRENCY_SOURCE,"company_id":_vm.company.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }